import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Navbar from '../components/site/Navbar';
import LogoMarquee from '../components/site/LogoMarquee';
import Blog from '../components/site/Blog';
import FooterCTA from '../components/site/FooterCTA';
import Footer from '../components/site/Footer';
import LogoWatermark from '../components/site/LogoWatermark';
import { services } from '../data/mock';

const ServicesHero = () => (
  <section className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden" style={{ background: '#12367F', color: '#FFFFFF' }}>
    <LogoWatermark size={560} opacity={0.08} position="left" />
    <div className="container-x px-6 relative">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7">
          <h1
            className="font-display uppercase text-balance"
            style={{ fontSize: 'clamp(3rem, 8.5vw, 9rem)', lineHeight: 0.88 }}
          >
            <span className="text-white">Both UK and USA</span>
            <br />
            <span className="text-white">Social-First</span>
            <br />
            <span style={{ color: '#2EF5FF' }}>Influencer</span>
            <br />
            <span style={{ color: '#2EF5FF' }}>Marketing Services</span>
            <br />
            <span style={{ color: '#2EF5FF' }}>Under One Roof</span>
          </h1>
        </div>
        <div className="lg:col-span-5 space-y-5 text-white/85 text-base md:text-lg leading-relaxed lg:pb-6">
          <p>
            From managing talent and crafting game-changing creator strategies to producing
            scroll-stopping content, we offer end-to-end influencer marketing services Both UK and
            USA brands trust. Whether you&apos;re based in the capital or scaling nationally, our
            influencer marketing services London team delivers it all under one roof.
          </p>
          <p>
            That expertise extends beyond managed talent. Through{' '}
            <span className="underline decoration-2 underline-offset-4 decoration-[#2EF5FF]">
              Nasu Academy
            </span>
            , we support and scale high-potential micro-creators, giving brands access to authentic
            voices alongside established talent. No middlemen. No fuss. Just the data, agility, and
            creative firepower that keep your brand ahead of the curve.
          </p>
          <div className="pt-4 flex flex-wrap gap-3">
            <a href="/contact" className="btn-base btn-accent">
              Book a strategy session <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const ServicesIntro = () => (
  <section className="pt-20 md:pt-28 pb-10 md:pb-14" style={{ background: '#FFFFFF' }}>
    <div className="container-x px-6 text-center">
      <span
        className="inline-block px-4 py-1.5 rounded-md font-display uppercase tracking-wider text-sm md:text-base"
        style={{ background: '#2EF5FF', color: '#12367F' }}
      >
        Our Services
      </span>
      <h2
        className="font-display uppercase text-[#12367F] text-balance mt-8 max-w-5xl mx-auto"
        style={{ fontSize: 'clamp(2.25rem, 5.5vw, 5rem)', lineHeight: 0.92 }}
      >
        You. Our creator network.
        <br />
        And the industry&apos;s best strategic minds.
      </h2>
    </div>
  </section>
);

const ServiceRow = ({ service, index }) => {
  const reverse = index % 2 === 1;
  return (
    <div className="container-x px-6 py-14 md:py-20">
      <div
        className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
          reverse ? '' : ''
        }`}
      >
        <div className={`lg:col-span-6 ${reverse ? 'lg:order-2' : ''}`}>
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] bg-[#12367F]/10 group">
            <img
              src={service.image}
              alt={service.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#12367F]/30" />
          </div>
        </div>
        <div className={`lg:col-span-6 ${reverse ? 'lg:order-1' : ''}`}>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-[#12367F]/60 font-medium mb-5">
            0{index + 1} / 0{services.length}
          </p>
          <h3
            className="font-display uppercase text-[#12367F]"
            style={{ fontSize: 'clamp(2.25rem, 5vw, 4.5rem)', lineHeight: 0.95 }}
          >
            {service.title}
          </h3>
          <div className="mt-6 space-y-5 text-[#12367F]/85 text-base md:text-lg leading-relaxed">
            {service.detail.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-8">
            <a href="/contact" className="btn-base btn-accent">
              Explore {service.title} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <main className="bg-white text-[#12367F]">
      <Navbar />
      <ServicesHero />
      <LogoMarquee />
      <ServicesIntro />
      <div className="divide-y divide-[#12367F]/10">
        {services.map((s, i) => (
          <ServiceRow key={s.id} service={s} index={i} />
        ))}
      </div>
      <Blog />
      <FooterCTA />
      <Footer />
    </main>
  );
};

export default Services;
